<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc1"><a href="#/chapter01">Spiritualism and Southern Culture: Making of Haunted Carthage</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">War Descends on Carthage: Fire and Depredation</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">Kendrick House: Antebellum Elegance and Haunting Spirits</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Civil War Stories: Whispers around the Campfire</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">Battle of Carthage Park: Eternal Reconnoiter</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Haunted Downtown: Postwar Growth</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">Logan Landmark: Family Fortune and Tragedy</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">Nighttime Visitors: The Watchers</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Prosperity School Bed and Breakfast: Ghostly Lessons</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Jasper County Courthouse: The Past Refuses to Fade Away</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Haunted Schools and Hospitals: Past and Present</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Burlingame &amp; Chaffee Opera House: Cannons, Theater and Murder?</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">Paranormal Investigation Methods</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0cd8f44c